import { useParams, Link } from 'react-router';
import { ComparisonLayout } from '../components/comparison/ComparisonLayout';
import { getCompetitorBySlug, competitors } from '../data/competitors';
import { MarketingHeader } from '../components/marketing/MarketingHeader';
import { MarketingFooter } from '../components/MarketingFooter';

/**
 * Renders a single Pollenate-vs-competitor comparison resolved from the URL
 * slug. One dynamic route serves every competitor in `competitors.ts`, so
 * adding a new comparison is just a data entry.
 */
export function ComparisonPage() {
  const { slug = '' } = useParams();
  const data = getCompetitorBySlug(slug);

  if (!data) {
    return (
      <div className="min-h-screen flex flex-col bg-[#fafafa] dark:bg-neutral-950">
        <MarketingHeader />
        <main className="flex-1 flex items-center justify-center px-4 py-24 text-center">
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Comparison not found</h1>
            <p className="mt-3 text-slate-600 dark:text-neutral-400">
              We couldn&rsquo;t find that comparison.
            </p>
            <Link to="/vs" className="mt-6 inline-flex items-center text-amber-600 dark:text-amber-400 hover:underline">
              See all comparisons &rarr;
            </Link>
          </div>
        </main>
        <MarketingFooter />
      </div>
    );
  }

  return <ComparisonLayout competitor={data} />;
}

// Re-export for convenience (used by data-driven routing / SSG enumeration).
export { competitors, getCompetitorBySlug };
